import { createFileRoute } from "@tanstack/react-router";

import PostList from "@/pages/post/PostList";

export const Route = createFileRoute("/post/")({
  component: PostList,
});
